import apiRequest from './api';

export function getBusinesses(token) {
  return apiRequest('/businesses', {
    method: 'GET',
    token,
  });
}

export function createBusiness(token, payload) {
  return apiRequest('/businesses', {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });
}

export function updateBusiness(token, businessId, payload) {
  const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;

  return apiRequest(`/businesses/${businessId}`, {
    method: 'PATCH',
    token,
    body: isFormData ? payload : JSON.stringify(payload),
  });
}

export function updateBusinessPreferences(token, businessId, payload) {
  return apiRequest(`/businesses/${businessId}/preferences`, {
    method: 'PATCH',
    token,
    body: JSON.stringify(payload),
  });
}

export function deleteBusiness(token, businessId) {
  return apiRequest(`/businesses/${businessId}`, {
    method: 'DELETE',
    token,
  });
}

export function updateBusinessOrder(token, businessIds) {
  return apiRequest('/businesses/preferences/order', {
    method: 'PATCH',
    token,
    body: JSON.stringify({
      business_ids: businessIds,
    }),
  });
}
